import axios from 'axios'
import router from '@/router'

// Configuration de base pour axios
const baseURL = import.meta.env.VITE_API_BASE_URL
const api = axios.create({
  baseURL: baseURL + '/api/v1',
  timeout: 60000, // Augmenter le timeout global à 60 secondes
  headers: {
    'Content-Type': 'application/json',
  },
})

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide -> nettoyer et rediriger si nécessaire sans recharger la page
      try {
        localStorage.removeItem('auth_token')
      } catch {
        console.error('Erreur lors de la suppression du token:', error)
      }
      const currentPath = window.location.pathname
      if (currentPath !== '/login') {
        try {
          await router.replace('/login')
        } catch {
          console.error('Erreur lors de la redirection vers la page de connexion:', error)
        }
      }
    }
    return Promise.reject(error)
  }
)

export default api
